export enum TemporaryPermanentEnum {
  temporary = 'Temporary',
  permanent = 'Permanent'
}

export enum TemporaryPermanentSimpleEnum {
  temporary = 'temporary',
  permanent = 'permanent'
}
